/* eslint-disable */
export const LISTAR = 'LISTAR';
export const AGREGAR = 'AGREGAR';